import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  inputLabel: {
    fontSize: "12px",
    textTransform: "uppercase",
    fontWeight: "bold",
    color: "#8F8F8F",
    marginLeft: theme.spacing(1),
  },
  input: {
    borderRadius: theme.spacing(1),
  },
}));

export default useStyles;
